module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CHAP-TITLE"
  }, [_vm._v("Magic Menagerie")]), _vm._v(" "), _c('p', {
    staticClass: "BOD2"
  }, [_vm._v("Use acid colours and simple shapes to create a cute and whimsical collection of feathered and furry friends. And wait for the snail!")]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "IMAGE"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/C1-20.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ecb653e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1-10.vue
// module id = 93
// module chunks = 0